import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

// Vuetify
import 'vuetify/styles'
import './style.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { mdi } from 'vuetify/iconsets/mdi'

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'dark',
    themes: {
      light: {
        colors: {
          primary: '#4CAF50',
          secondary: '#81C784',
          accent: '#8BC34A',
          error: '#F44336',
          warning: '#FF9800',
          info: '#2196F3',
          success: '#4CAF50',
          surface: '#FFFFFF',
          background: '#F5F5F5'
        }
      },
      dark: {
        colors: {
          primary: '#69F0AE',
          secondary: '#81C784',
          accent: '#A7FFEB',
          error: '#FF5252',
          warning: '#FFB74D',
          info: '#40C4FF',
          success: '#69F0AE',
          surface: '#1A1A1A',
          background: '#0D0D0D',
          'surface-bright': '#2A2A2A',
          'surface-variant': '#2E2E2E',
          'surface-container': '#242424',
          'surface-container-high': '#2F2F2F',
          'surface-container-highest': '#393939',
          'on-surface': '#F0F0F0',
          'on-background': '#F0F0F0',
          'on-primary': '#003300',
          'on-secondary': '#1B5E20',
          'outline': '#4E4E4E',
          'outline-variant': '#383838'
        }
      }
    }
  }
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)

app.mount('#app')